export const parseBoolean = (value?: string) =>
	!!(value === '1' || value === 'true');

export const getSafeValue = (selectValue: any) => {
	if (
		typeof selectValue === 'object' &&
		selectValue !== null &&
		'value' in selectValue
	) {
		return selectValue.value;
	}
	return selectValue;
};

export const parseRequired = (value: any) => {
	return value !== false && value !== undefined && value !== null;
};
